'use client';

export const scrollToViewPromise = (
  target: string,
  behavior: ScrollBehavior = 'smooth',
  offset = 0,
  updateHash = false,
): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.reject();
  }

  const element = document.getElementById(target);

  if (updateHash) window.history.pushState(null, '', `#${target}`);

  if (!element) return Promise.reject();
  const y = element.getBoundingClientRect().top + window.scrollY - offset;

  setTimeout(() => {
    window.scrollTo({ top: y, behavior: behavior });
  }, 150);

  return new Promise(resolve => {
    const diffToTarget = Math.abs(y - window.scrollY);
    if (Math.floor(diffToTarget) < 1) {
      resolve();
    } else {
      const scrollHandler = () => {
        if (Math.floor(y) === Math.floor(window.scrollY)) {
          window.removeEventListener('scroll', scrollHandler);
          resolve();
        }
      };
      window.addEventListener('scroll', scrollHandler);
    }
  });
};
